import { Routes } from '@angular/router';
import { canActivate } from '@angular/fire/auth-guard';
import { onlyPermissions, redirectUnauthorizedToLogin } from 'projects/shared-lib/src/core/permissions/guard-utils';

export const routes: Routes = [
  { path: '', loadComponent: () => import('./layout/layout.page').then((m) => m.LayoutPage), ...canActivate(redirectUnauthorizedToLogin),
    children:[
      { path: "projects", data: { breadcrumb: 'LABEL.PROJECTS' },  loadChildren: () => import("./modules/private/projects/projects.routes").then((m) => m.routes) },
      { path: "settings", data: { breadcrumb: 'LABEL.SETTINGS' }, loadChildren: () => import("./modules/private/settings/settings.routes").then((m) => m.routes) },
      { path: "systemAdmin", loadComponent: () => import("./modules/private/systemAdmin/systemAdmin-page").then((m) => m.SystemAdminPage) },

      { path: '',   redirectTo: 'projects',  pathMatch: 'full'  }, // redirect to
    ]
  },
  { path: 'home', loadComponent: () => import('@public/landing/landing.component').then(m => m.LandingComponent) },
  { path: 'login', data: { breadcrumb: 'Login' }, loadComponent: () => import('@public/login/login.component').then(m => m.LoginComponent) },
  { path: 'forgotpassword', data: { breadcrumb: 'Login' }, loadComponent: () => import('@public/forgotpassword/forgotpassword.component').then(m => m.ForgotPasswordComponent) },
  { path: 'au', data: { breadcrumb: 'Authentication Verification' }, loadChildren: () => import('@public/auth-verify/auth-verify.routes').then(m => m.routes) },
  { path: "notfound", loadComponent: () => import('@public/notfound/notfound.component').then(m=>m.NotfoundComponent)},
  { path: '**',   redirectTo: 'home', pathMatch: 'full' },
  // { path: "project-edit", loadChildren: () => import("./modules/private/project-edit/project-edit.routes").then((m) => m.routes) },
];
